import { lazy } from "react";
import { Navigate } from "react-router-dom";

const HomeLayout = lazy(() => import("../layouts/HomeLayout.jsx"));
const DesignLayout = lazy(() => import("../layouts/DesignLayout.jsx"));
const SubmissionLayout = lazy(() => import("../layouts/SubmissionLayout.jsx"));
const ResultLayout = lazy(() => import("../layouts/ResultLayout.jsx"));
const DssLayout = lazy(() => import("../layouts/DssLayout.jsx"));
const UserLayout = lazy(() => import("../layouts/UserLayout.jsx"));
const ContactsLayout = lazy(() => import("../layouts/ContactsLayout.jsx"));
const ErrorLayout = lazy(() => import("../layouts/ErrorLayout.jsx"));
const SupportLayout = lazy(() => import("../layouts/SupportLayout.jsx"));
const AdminLayout = lazy(() => import("../layouts/AdminLayout.jsx"));
const MediaLayout = lazy(() => import("../layouts/MediaLayout.jsx"));


const HomeView = lazy(() => import("../views/home/HomeView.jsx"));
const DesignHomeView = lazy(() => import("../views/design/DesignHomeView.jsx"));
const PreviewHomeView = lazy(() => import("../views/design/preview/PreviewHomeView.jsx"));
const SubmissionHomeView = lazy(() => import("../views/submission/SubmissionHomeView.jsx"));
const SubmissionSuccessView = lazy(() => import("../views/submission/SubmissionSuccessView.jsx"));
const SubmissionClosedView = lazy(() => import("../views/submission/SubmissionClosedView.jsx"));
const SubmissionInvalidView = lazy(() => import("../views/submission/SubmissionInvalidView.jsx"));

const ResultHomeView = lazy(() => import("../views/result/ResultHomeView.jsx"));

//const UserFormHomeView = lazy(() => import("../views/user/forms/UserFormHomeView.jsx"));
const UserFormDashBoard = lazy(() => import("../views/user/myForms/FormsDashboard.jsx"));
const ContactGroupHomeView = lazy(() => import("../views/user/contacts/ContactGroupHomeView.jsx"));

const AccountView = lazy(() => import("../views/user/account/AccountView.jsx"));



const SignInView = lazy(() => import("../views/dss/SignInView.jsx"));
const SignUpView = lazy(() => import("../views/dss/SignUpView.jsx"));
const EmailRegistrySuccessView = lazy(() => import("../views/dss/EmailRegistrySuccessView.jsx"));
const PasswordResetView = lazy(() => import("../views/dss/PasswordResetView.jsx"));
const PasswordUpdateView = lazy(() => import("../views/dss/PasswordUpdateView.jsx"));
const PasswordUpdateSuccessView = lazy(() => import("../views/dss/PasswordUpdateSuccessView.jsx"));

const UnAuthorizedView = lazy(() => import("../views/error/UnAuthorizedView.jsx"));
const InvalidResourceView = lazy(() => import("../views/error/InvalidResourceView.jsx"));

const SupportHomeView = lazy(() => import("../views/support/SupportHomeView.jsx"));
const SupportSuccess = lazy(() => import("../views/support/SupportSuccess.jsx"));


const AdminTemplatesView = lazy(() => import("../views/admin/AdminTemplatesView.jsx"));
const AdminViewTemplateView = lazy(() => import("../views/admin/AdminViewTemplateView.jsx"));
const AdminTemplateCategoryView = lazy(() => import("../views/admin/AdminTemplateCategoryView.jsx"));
const AdminTemplateSuggestionsView = lazy(() => import("../views/admin/AdminTemplateSuggestionsView.jsx"));

const MediaLightBox = lazy(() => import("../views/media/MediaLightbox.jsx"));


/** Research & Development */
const ResearchDevelopmentView = lazy(() => import("../R&D/ResearchDevelopmentView.jsx"));
const UpdateNestedElementView = lazy(() => import("../R&D/UpdateNestedElementView.jsx"));
const DragUpDownListView = lazy(() => import("../R&D/DragUpDownListView.jsx"));
const RecordVoiceView = lazy(() => import("../R&D/RecordVoiceView.jsx"));
const ColorPickerView = lazy(() => import("../R&D/ColorPickerView.jsx"));
const ImageOptionView = lazy(() => import("../R&D/ImageOptionView.jsx"));
const TourView = lazy(() => import("../R&D/ReactTourView.jsx"));
const RoundCornerLayoutView = lazy(() => import("../R&D/RoundCornerLayoutView.jsx"));
const RoundCornerGradientLayoutView = lazy(() => import("../R&D/RoundCornerLayoutView_gradient.jsx"));
const MobileLayout = lazy(() => import("../R&D/PermanantDrawerMobile.jsx"));
const DrawerAnimationFix = lazy(() => import("../R&D/DrawerAnimationFix.jsx"));
const TextEditorView = lazy(() => import("../R&D/TextEditorView.jsx"));
const MenuGroupView = lazy(() => import("../R&D/MenuGroupView.jsx"));
const AbstractImageView = lazy(() => import("../R&D/AbstractImageView.jsx"));
const GeminiAiView = lazy(() => import("../R&D/GeminiAiView.jsx"));
const TextStyleToolBoxView = lazy(() => import("../R&D/TextStyleToolBoxView.jsx"));
const DatasourceView =  lazy(() => import("../R&D/AddDatasourcePage.jsx"));
const MyForms = lazy(() => import("../R&D/forms/AdvancedFormsDashboard.jsx"));
const FormBuilder = lazy(() => import("../R&D/formBuilder/builder/FormBuilder.jsx")); 
const FormSubmission = lazy(() => import("../R&D/formBuilder/submission/UserFormSubmissionPage.jsx")); 
const ModernNavigation =  lazy(() => import("../R&D/ModernNavigation.jsx"));


const ThemeRoutes = [
    {
        path: "/",
        element: <HomeLayout />,
        children: [
            { path: "", exact: true, element: <HomeView /> },
            { path: "support", exact: true, element: <HomeView /> },
        ]
    },

    {
        path: "/design",
        element: <DesignLayout />,
        children: [
            { path: "", exact: true, element: <DesignHomeView /> },
            { path: "preview/*", exact: true, element: <PreviewHomeView /> },
        ]
    },

    {
        path: "/sub",
        element: <SubmissionLayout />,
        children: [
            { path: "closed", exact: true, element: <SubmissionClosedView /> },
            { path: "invalid", exact: true, element: <SubmissionInvalidView /> },
            { path: ":formId/:lookup?", exact: true, element: <SubmissionHomeView /> },
            { path: "success/:subId", exact: true, element: <SubmissionSuccessView /> }
        ]
    },

    {
        path: "/res",
        element: <ResultLayout />,
        children: [
            { path: ":formId/", exact: true, element: <ResultHomeView /> },
        ]
    },

    {
        path: "/media",
        element: <MediaLayout />,
        children: [
            { path: "lightbox", exact: true, element: <MediaLightBox /> },
        ]
    },

    {
        path: "/dss",
        element: <DssLayout />,
        children: [
            { path: "signin", exact: true, element: <SignInView /> },
            { path: "signup", exact: true, element: <SignUpView /> },
            { path: "registry/success", exact: true, element: <EmailRegistrySuccessView /> },
            { path: "password/reset", exact: true, element: <PasswordResetView /> },
            { path: "password/update", exact: true, element: <PasswordUpdateView /> },
            { path: "password/update/success", exact: true, element: <PasswordUpdateSuccessView /> }
        ]
    },

    {
        path: "/u",
        element: <UserLayout />,
        children: [
            //{ path: "forms", exact: true, element: <UserFormHomeView /> },//old
            { path: "forms", exact: true, element: <UserFormDashBoard /> },//new
            { path: "contacts", exact: true, element: <ContactGroupHomeView /> },
            { path: "account", exact: true, element: <AccountView /> },
        ]
    },

    {
        path: "/contacts",
        element: <ContactsLayout />,
        children: [
            { path: "", exact: true, element: <ContactGroupHomeView /> },
        ]
    },

    {
        path: "/error",
        element: <ErrorLayout />,
        children: [
            { path: "unauthorized", exact: true, element: <UnAuthorizedView /> },
            { path: "invalid", exact: true, element: <InvalidResourceView /> },
        ]
    },

    {
        path: "/support",
        element: <SupportLayout />,
        children: [
            { path: "", exact: true, element: <SupportHomeView /> },
            { path: "success", exact: true, element: <SupportSuccess /> },
        ]
    },

    {
        path: "/admin",
        element: <AdminLayout />,
        children: [
            { path: "", exact: true, element: <Navigate to="templates" replace /> },
            { path: "templates", exact: true, element: <AdminTemplatesView /> },
            { path: "template/:id", exact: true, element: <AdminViewTemplateView /> },
            { path: "category", exact: true, element: <AdminTemplateCategoryView /> },
            { path: "suggestions", exact: true, element: <AdminTemplateSuggestionsView /> },
        ]
    },

    {
        path: "/rd",
        element: <DesignLayout />,
        children: [
            { path: "", exact: true, element: <ResearchDevelopmentView /> },
            { path: "TOVFORM-12", exact: true, element: <UpdateNestedElementView /> },
            { path: "TOVFORM-37", exact: true, element: <DragUpDownListView /> },
            { path: "TOVFORM-5", exact: true, element: <RecordVoiceView /> },
            { path: "color", exact: true, element: <ColorPickerView /> },
            { path: "imageoption", exact: true, element: <ImageOptionView /> },
            { path: "tour", exact: true, element: <TourView /> },
            { path: "roundCorner", exact: true, element: <RoundCornerLayoutView /> },
            { path: "roundCorner_gr", exact: true, element: <RoundCornerGradientLayoutView /> },
            { path: "mobileLayout", exact: true, element: <MobileLayout /> },
            { path: "drawerAnimationFix", exact: true, element: <DrawerAnimationFix /> },
            { path: "textEditor", exact: true, element: <TextEditorView /> },
            { path: "menuGroup", exact: true, element: <MenuGroupView /> },
            { path: "abstractImage", exact: true, element: <AbstractImageView /> },
            { path: "geminiAi", exact: true, element: <GeminiAiView /> },
            { path: "textStyleToolBox", exact: true, element: <TextStyleToolBoxView /> },
            { path: "datasource", exact: true, element: <DatasourceView /> },
            { path: "forms", exact: true, element: <MyForms /> }, 
            { path: "formBuilder", exact: true, element: <FormBuilder /> },   
            { path: "formSubmission", exact: true, element: <FormSubmission /> },   
            { path: "bottomNav", exact: true, element: <ModernNavigation /> },
            
            

        ]
    }

]
export default ThemeRoutes;